import { Box, Grid } from "@mui/material";
import {
	EmailFieldRHF,
	EnhancedDropDownRHFWithLabel,
	EnhancedMultiDropDownRHFWithLabel,
	ExtensionNumberRHF,
	ITest,
	LabelPosition,
	PhoneNumberRHF,
	PostCodeRHF,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../../common/constants";
import { sortDDLByLabel, useNavigateToLogout } from "../../../../common/Common";

import { CityService } from "../../../../services/CityService";
import { CountryService } from "../../../../services/common/CountryService";
import { ProvinceService } from "../../../../services/common/ProvinceService";
import { StateService } from "../../../../services/common/USAStateService";
import { useQuery } from "@tanstack/react-query";

// import { GET_QUERY_KEY, QUERY_OPTIONS } from "common/constants";
// import { ProvinceService } from "services/common/ProvinceService";








interface IClientAddressSetupFieldsPanel extends ITest {
	countryList: {
		shortCode?: string;
		label: string;
		value: string;
		countryType: string;
	}[];
	provinceDDLLoading: (value: boolean) => void;
	formMethods: any;
	provinceStateDDLinUpdate: any;
	provinceStateLabelinUpdate: any;
	isAdminUser: any;
	cityDDLinUpdate: any;
	clientStoreId: any;
	loadedClientId: any;
	setDefaultSelectedCountry: (value: any) => void
}
export let provinceResponce: any = undefined;
export const ClientAddressSetupFieldsPanel: FC<
	IClientAddressSetupFieldsPanel
> = ({
	countryList,
	provinceDDLLoading,
	formMethods,
	provinceStateDDLinUpdate,
	provinceStateLabelinUpdate,
	isAdminUser,
	cityDDLinUpdate,
	clientStoreId,
	loadedClientId,
	setDefaultSelectedCountry
}) => {
		const [provinceOrStateDDL, setprovinceOrStateDDL] = useState(undefined);
		const [cityDDL, setCityDDL] = useState(undefined);

		const [countrytype, setCountrytype] = useState("Province");
		const [selectedCountryShortCode, setSelectedCountryShortCode] = useState("");
		const [selectedCountry, setSelectedCountry] = useState<any>("");
		const useGetProvinceDDL = () => {
			return useQuery({
				queryKey: [GET_QUERY_KEY.PROVINCE_DDL],
				queryFn: () => ProvinceService.get(),
				...QUERY_OPTIONS,
			});
		};
		const { data: provinceList } = useGetProvinceDDL();
		const navigateToLogout = useNavigateToLogout();

		// const useGetCountryDDL = () => {
		//   return useQuery(GET_QUERY_KEY.COUNTRY_DDL, () => CountryService.get(), {
		//     ...QUERY_OPTIONS,
		//   });
		// };
		// const { data: countryList } =
		// useGetCountryDDL();

		const useGetStateDDL = () => {
			return useQuery({
				queryKey: [GET_QUERY_KEY.USA_STATE_DDL],
				queryFn: () => StateService.get(),
				...QUERY_OPTIONS,
			});
		};
		const { data: stateList } = useGetStateDDL();

		const onCountryChangeHandler = async (e: any) => {

			setSelectedCountry(e.value);
			setDefaultSelectedCountry(e.value);
			setSelectedCountryShortCode(e.shortCode);
			let selected = e.value;
			setCountrytype(
				e.countryType === "province"
					? "Province"
					: e.countryType === "state"
						? "State"
						: e.countryType
			);
			formMethods.setValue("province", undefined);
			formMethods.setValue("state", undefined);
			try {
				provinceDDLLoading(true);
				const responce = await CountryService.getProvinceOrStateDDL(
					navigateToLogout,
					selected,
					e.countryType
				);
				setprovinceOrStateDDL(responce);
			} catch {

			} finally {
				provinceDDLLoading(false);
			}
		};

		const onProvinceChangeHandler = async (e: any) => {
			let selected = e.value;
			formMethods.setValue("city", undefined);
			try {
				provinceDDLLoading(true);
				const responce = await CityService.getCityDDL(navigateToLogout, selected);
				setCityDDL(responce);
			} catch {

			} finally {
				provinceDDLLoading(false);
			}
		};

		useEffect(() => {
			if (provinceStateDDLinUpdate && provinceStateLabelinUpdate) {

				setprovinceOrStateDDL(provinceStateDDLinUpdate);
				setCountrytype(
					provinceStateLabelinUpdate === "province"
						? "Province"
						: provinceStateLabelinUpdate === "state"
							? "State"
							: provinceStateLabelinUpdate
				);
				setSelectedCountryShortCode(
					provinceStateLabelinUpdate === "province"
						? "CAN"
						: provinceStateLabelinUpdate === "state"
							? "USA"
							: provinceStateLabelinUpdate
				);
			}
			if (cityDDLinUpdate) {
				setCityDDL(cityDDLinUpdate);
			}
			console.log('loadedClientId', loadedClientId)
			// if (countryList && !loadedClientId) {
			if (countryList) {
				const canada = countryList.find(
					(item: any) => item.label === "Canada" || "canada"
				);
				if (canada) {
					setSelectedCountry(canada.value);
					setDefaultSelectedCountry(canada.value);
					setSelectedCountryShortCode(canada.shortCode ? canada.shortCode : "");
					(async () => {
						try {
							provinceDDLLoading(true);
							const response = await CountryService.getProvinceOrStateDDL(
								navigateToLogout,
								canada.value,
								"Province"
							);
							setprovinceOrStateDDL(response);
							//   provinceDDLItems(response);
						} catch (err) {
							console.error("error", err);
						} finally {
							provinceDDLLoading(false);
						}
					})();
				}
			}

		}, [
			provinceStateLabelinUpdate,
			provinceStateDDLinUpdate,
			countryList,
			cityDDLinUpdate,
			loadedClientId
		]);

		return (
			<>
				<RHookFormTextFieldWithLabel
					label="Address"
					id="addressLine1"
					testId={`address`}
					labelPosition={LabelPosition.Top}
				// required
				/>
				{/* <RHookFormTextFieldWithLabel
				label="City"
				id="city"
				testId={`city`}
				labelPosition={LabelPosition.Top}
				// required
			/> */}

				{countryList && selectedCountry && (
					<EnhancedDropDownRHFWithLabel
						selectName="country"
						label="Country"
						labelPosition={LabelPosition.Top}
						// required
						testId={`country-list`}
						items={countryList ?? []}
						selectedItem={selectedCountry}
						labelColumns={4}
						fieldColumns={8}
						onSelectionChangeHandler={onCountryChangeHandler}
					/>
				)}

				{provinceOrStateDDL && (
					<EnhancedDropDownRHFWithLabel
						selectName={"province"}
						label={countrytype}
						labelPosition={LabelPosition.Top}
						// required
						testId={`province-list`}
						items={provinceOrStateDDL ?? []}
						labelColumns={4}
						fieldColumns={8}
						onSelectionChangeHandler={onProvinceChangeHandler}
					/>
				)}

				{provinceOrStateDDL && cityDDL && (
					<EnhancedDropDownRHFWithLabel
						selectName={"city"}
						label={"City"}
						labelPosition={LabelPosition.Top}
						// required
						testId={`city-list`}
						items={cityDDL && sortDDLByLabel(cityDDL ?? [])}
					/>
				)}

				{selectedCountryShortCode === "CAN" ? (
					<PostCodeRHF
						label="Post Code"
						id="postCode"
						testId={`accountant-post-code`}
						labelPosition={LabelPosition.Top}
						labelColumns={4}
						fieldColumns={8}
					// required
					/>
				) : selectedCountryShortCode === "USA" ? (
					<RHookFormMaskedTextFieldWithLabel
						label="Zip Code"
						id="zipCode"
						testId={`Zip-Code`}
						labelPosition={LabelPosition.Top}
						placeholder={"00000"}
						// required
						inputMaskPattern={"00000"}
						labelColumns={4}
						fieldColumns={8}
					/>
				) : (
					<></>
				)}
				{/* {selectedCountryShortCode !== "" && (selectedCountryShortCode === "CAN") || (selectedCountryShortCode === "USA") ? <RHookFormMaskedTextFieldWithLabel
                        label={selectedCountryShortCode === "USA" ? "Zip Code" : selectedCountryShortCode === "CAN" ? "Postal Code" : ""}
                        id={selectedCountryShortCode === "USA" ? "zipCode" : selectedCountryShortCode === "CAN" ? "postalCode" : ""}
                        testId={`Zip-Code`}
                        labelPosition={LabelPosition.Top}
                        placeholder={selectedCountryShortCode === "USA" ? "00000" : selectedCountryShortCode === "CAN" ? "A0A0A0" : ""}
                        required
                        inputMaskPattern={selectedCountryShortCode === "USA" ? "00000" : selectedCountryShortCode === "CAN" ? "a0a0a0" : ""}
                        labelColumns={4}
                        fieldColumns={8}
                      /> : <></>} */}


				<PhoneNumberRHF
					id="phone"
					label="Phone 1"
					// required
					labelPosition={LabelPosition.Top}
					testId="phoneNumber"
					labelColumns={4}
					fieldColumns={8}
				/>
				<PhoneNumberRHF
					id="phone2"
					label="Phone 2"
					// required
					labelPosition={LabelPosition.Top}
					testId="phoneNumber"
					labelColumns={4}
					fieldColumns={8}
				/>
				<PhoneNumberRHF
					id="tollFree"
					label="Toll Free"
					// required={false}
					labelPosition={LabelPosition.Top}
					testId="Toll FreeNumber"
					labelColumns={4}
					fieldColumns={8}
				/>
				<RHookFormTextFieldWithLabel
					label="WebSite"
					id="website"
					testId={`WebSite`}
					labelPosition={LabelPosition.Top}
				// required
				/>

			</>
		);
	};
